import React, { PureComponent } from 'react';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';

import App from './App';

const theme = createMuiTheme({
  palette: {
    type: 'dark'
  },
  overrides: {
    MuiButton: {
      root: {
        textTransform: 'unset'
      }
    }
  }
});

class AppProvider extends PureComponent {
  render() {
    return (
      <MuiThemeProvider theme={theme}>
        <App />
      </MuiThemeProvider>
    );
  }
}

export default AppProvider;
